import React, { useEffect, useRef, useState } from 'react';

export const isIntegratedPersonPhoto = field => ['students', 'attendees'].includes(field?.moduleBinding?.moduleKey) && field.moduleBinding.moduleField === 'photoUrl';
const MAX_PHOTO_SIZE = 5 * 1024 * 1024;

export default function IntegratedPersonPhotoInput({ field, value, readOnly, onChange }) {
  const reader = useRef(null);
  const input = useRef(null);
  const [error, setError] = useState('');
  const [reading, setReading] = useState(false);
  useEffect(() => () => reader.current?.abort(), []);
  const source = typeof value === 'string' ? value : value?.dataUrl;
  const photo = typeof source === 'string' && /^data:image\/(png|jpeg|webp|gif);base64,/.test(source) ? source : '';
  const select = event => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (!['image/png', 'image/jpeg', 'image/webp', 'image/gif'].includes(file.type) || file.size > MAX_PHOTO_SIZE) {
      setError('Selecione uma imagem PNG, JPEG, WebP ou GIF de até 5 MB.');
      event.target.value = '';
      return;
    }
    reader.current?.abort();
    const current = new FileReader();
    reader.current = current;
    setError('');
    setReading(true);
    input.current?.setCustomValidity('Aguarde a leitura da foto.');
    const finish = () => { setReading(false); input.current?.setCustomValidity(''); };
    current.onload = () => { onChange({ name: file.name, dataUrl: String(current.result || '') }); finish(); };
    current.onerror = () => { setError('Não foi possível ler a foto.'); finish(); };
    current.readAsDataURL(file);
  };
  return <div className="space-y-2">
    {photo && <img src={photo} alt="Foto do cadastro" className="h-32 w-32 rounded-lg object-cover" />}
    {!readOnly && <input ref={input} id={field.id} type="file" accept="image/png,image/jpeg,image/webp,image/gif" required={field.required && !photo} aria-busy={reading} onChange={select} />}
    {!readOnly && photo && <button type="button" disabled={reading} onClick={() => { onChange(''); if (input.current) input.current.value = ''; }}>Remover foto</button>}
    {!readOnly && <p className="text-xs text-slate-500">Foto opcional. PNG, JPEG, WebP ou GIF, até 5 MB.</p>}
    {reading && <p role="status">Lendo foto...</p>}
    {error && <p role="alert">{error}</p>}
  </div>;
}
